import { SVGProps } from '@components/Icon/types';

export const LassoSelect = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2.05, 3.3)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.03917 0.239164C10.0091 0.0713072 10.9572 -0.0068647 11.8656 0.000471763C12.1679 0.0029132 12.4668 0.0155816 12.7605 0.0366594C13.9335 0.120859 15.0198 0.351061 15.9776 0.714126C17.9006 1.44304 19.3426 2.76454 19.6085 4.52135C19.8748 6.28139 18.906 7.99361 17.3018 9.32913C15.7034 10.6598 13.4541 11.666 10.866 12.1129C10.1624 12.2345 9.47621 12.29 8.79533 12.3169L8.5951 12.3248L8.52572 12.5128C8.1453 13.5435 7.15955 14.2865 6.01275 14.2865C5.7671 14.2865 5.5274 14.2405 5.28312 14.17L5.04331 14.1007L3.33697 17.5113L2.09236 16.889L3.90648 13.2628L3.80523 13.1167C3.50604 12.6849 3.32842 12.1674 3.32585 11.6118L3.32736 11.5991C3.32834 11.5897 3.32945 11.5766 3.32968 11.5612L3.33244 11.3728L3.16391 11.2885C1.6404 10.5265 0.525402 9.34448 0.296617 7.83271C0.0302759 6.0728 0.999235 4.36045 2.60328 3.02492C4.20157 1.69417 6.45073 0.687134 9.03917 0.239164ZM11.8534 1.39762C11.0311 1.38957 10.1638 1.45629 9.27522 1.61007C6.91015 2.01938 4.85224 2.9626 3.49309 4.09423C2.14287 5.21843 1.50009 6.48067 1.67327 7.62496C1.81484 8.56045 2.51246 9.34583 3.61278 9.93854L3.82575 10.0533L3.98301 9.86945C4.48128 9.28704 5.20546 8.91266 6.01275 8.91266C7.1734 8.91266 8.16803 9.6744 8.53779 10.7249L8.61183 10.9353L8.83457 10.925C9.41527 10.8983 10.0125 10.8487 10.6298 10.7421C12.9942 10.3337 15.0508 9.39146 16.41 8.25983C17.7601 7.13587 18.405 5.8735 18.2318 4.7291C18.058 3.58072 17.0896 2.62449 15.4844 2.01602C14.4727 1.63254 13.2224 1.41102 11.8534 1.39762ZM6.01275 10.304C5.28539 10.304 4.71711 10.8722 4.71711 11.5996C4.71711 12.327 5.28539 12.8952 6.01275 12.8952C6.74011 12.8952 7.3084 12.327 7.3084 11.5996C7.3084 10.8722 6.74011 10.304 6.01275 10.304Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'lasso-select';
